import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {FormField} from '@cred/react-form-field'
import {Label} from '@cred/react-label'
import Font from '@cred/react-font'
import {event} from '@cred/shared/ga'
import {tooltipInteraction} from '@cred/react-analytics/events'
import {withSnowplowContexts} from '@cred/react-analytics/SnowplowContextManager'

import {regexp, passValidation} from './config'
import {LoadingSpinner} from '../loading_spinner'
import defaultStyles from './themes/default/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'

import withStyles from '@cred/react-theme'

const PassTooltipNoHoc = props => {
  const {styles} = props

  return (
    <div
      id="pass-tooltip"
      className={[styles.authorize__passTooltip, props.showTooltip ? styles.tooltipActive : '', props.displayLeft ? styles.displayLeft : styles.displayRight].join(' ')}
    >
      <div className={styles.tooltipArrow}/>
      <div className={[styles.tooltipBody, 'align-left'].join(' ')}>
        <Font type="bodySmall" weight="bold" className={styles.title}>
          Password requirements
        </Font>
        <ul className={styles.tooltip__list}>
          <Font element="li" type="bodySmall" className={[styles.tooltip__element, passValidation(regexp.uppercase, props.value) ? styles.valid : ''].join(' ')}>
            Uppercase letter
          </Font>
          <Font element="li" type="bodySmall" className={[styles.tooltip__element, passValidation(regexp.lowercase, props.value) ? styles.valid : ''].join(' ')}>
            Lowercase letter
          </Font>
          <Font element="li" type="bodySmall" className={[styles.tooltip__element, passValidation(regexp.number, props.value) ? styles.valid : ''].join(' ')}>
            Number
          </Font>
          <Font element="li" type="bodySmall" className={[styles.tooltip__element, passValidation(regexp.minCharacters, props.value) ? styles.valid : ''].join(' ')}>
            Minimum 8 characters
          </Font>
          {props.value.length
            ? (!passValidation(regexp.spaceStart, props.value) ||
              !passValidation(regexp.spaceEnd, props.value)) &&
            <Font type="bodySmall" element="li" color="error" className={[styles.tooltip__element, styles.failed].join(' ')}>Cannot start or end with a space or tab</Font>
            : ''}
        </ul>
      </div>
    </div>
  )
}

PassTooltipNoHoc.propTypes = {
  showTooltip: PropTypes.bool,
  value: PropTypes.string.isRequired,
  displayLeft: PropTypes.bool,
  styles: PropTypes.object
}

PassTooltipNoHoc.defaultProps = {
  showTooltip: false,
  displayLeft: false,
  styles: defaultStyles
}

const PassTooltip = withStyles(defaultStyles, {credible3})(PassTooltipNoHoc)

/**
 * @visibleName Password
 */
class PassInputWithAnalytics extends Component {
  static propTypes = {
    withoutTooltip: PropTypes.bool,
    input: PropTypes.any.isRequired,
    label: PropTypes.string,
    meta: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    loading: PropTypes.bool,
    getInputRef: PropTypes.func,
    styles: PropTypes.object
  }

  static defaultProps = {
    withoutTooltip: false,
    label: 'Password',
    placeholder: 'Minimum 8 characters',
    loading: false,
    getInputRef: () => {},
    styles: defaultStyles
  }

  state = {
    showPass: false,
    showTooltip: false
  }

  changeInputType = () => {
    const {showPass} = this.state,
      {analytics} = this.props,
      {category, action} = analytics

    this.setState(state => ({showPass: !state.showPass}))

    if (category) {
      event({category, action, label: showPass ? 'Hide' : 'Show'})
    }
  }

  componentDidUpdate() {
    const {meta} = this.props,
      showTooltip = !meta.valid && meta.active

    if (this.state.showTooltip !== showTooltip) {
      this.setState({showTooltip})
      this.fireTooltipEvent(showTooltip)
    }
  }

  fireTooltipEvent(showTooltip) {
    const {trackSnowplowEvent} = this.props

    trackSnowplowEvent(tooltipInteraction, {content: 'Password requirements', action: showTooltip ? 'show' : 'hide'})
  }

  render() {
    const {input, label, meta, placeholder, withoutTooltip, loading, displayLeft, getInputRef, styles} = this.props
    const {showPass} = this.state
    const credIconClass = showPass ? 'icon-eye-off' : 'icon-eye'

    return (
      <FormField
        className={styles.parent}
        status={meta}
        error={meta.error}
        value={input.value}
        withoutTooltip={withoutTooltip}
        label={label}
      >
        <div className={styles.inputWrapper}>
          <input
            type={this.state.showPass ? 'text' : 'password'}
            placeholder={placeholder}
            ref={getInputRef}
            {...input}
          />
          <LoadingSpinner open={loading}/>
          <i
            className={[styles.showPass, 'cred-icon', loading ? '' : credIconClass].join(' ')}
            onClick={this.changeInputType}
            title="Click here show/hide password"
          />
          {!withoutTooltip && <PassTooltip showTooltip={!meta.valid && meta.active} value={input.value} displayLeft={displayLeft}/>}
        </div>
        <Label>{label}</Label>
      </FormField>
    )
  }
}

const PassInput = /*#__PURE__*/ compose(
  withStyles(defaultStyles, {credible3}),
  withSnowplowContexts
)(PassInputWithAnalytics)

export {PassInput, PassTooltipNoHoc}

export default PassInput
